import { MutableRefObject, useEffect, useState } from 'react';
import throttle from 'lodash/throttle';
import { getOffsetTop, getScrollTop } from '../common/WithScrollingView';
import { Nullable } from '../types/common';

const useStickElementOnScroll = (containerRef: MutableRefObject<Nullable<HTMLDivElement>>) => {
  const [portalActive, setPortalActive] = useState(false);
  const [portal, setPortal] = useState<undefined | Nullable<Element>>(undefined);

  useEffect(() => {
    const portalElement = document?.querySelector?.('.header-navigation-portal') || document?.querySelector?.('.header-nav__portal');
    setPortal(portalElement);
  }, []);

  useEffect(() => {
    const onScrollHandler = () => {
      const scrollTop = getScrollTop();
      const offsetTop = getOffsetTop(containerRef?.current);
      const headerHeight = (document.querySelector('.header-nav') as HTMLElement)?.offsetHeight || 0;
      const isPortalActive = scrollTop + headerHeight > offsetTop;

      if (portalActive !== isPortalActive) {
        setPortalActive(isPortalActive);
      }
      return isPortalActive;
    };

    const throttledOnScroll = throttle(onScrollHandler, 500);

    window.addEventListener('scroll', throttledOnScroll);

    return () => {
      window.removeEventListener('scroll', throttledOnScroll);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [portalActive]);

  return {
    shouldRenderPortal: !!(portalActive && portal),
    portal,
  };
};

export default useStickElementOnScroll;
